import { render, staticRenderFns } from "./entity-tab-item.vue?vue&type=template&id=a98abd54&scoped=true&"
import script from "./entity-tab-item.vue?vue&type=script&lang=js&"
export * from "./entity-tab-item.vue?vue&type=script&lang=js&"
import style0 from "./entity-tab-item.vue?vue&type=style&index=0&id=a98abd54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98abd54",
  null
  
)

export default component.exports